// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","favourite":"Card_favourite__unIR+","cardBottom":"Card_cardBottom__0Jt4Y","button":"Card_button__FUwwJ"};